import React, { HTMLAttributes } from 'react';
interface IconProps extends HTMLAttributes<SVGElement> {
	width?: number | string;
	height?: number | string;
}
export const NoDataFineTuneIcon = ({
	width = 200,
	height = 200,
	...restProps
}: IconProps) => {
	return (
    <svg
    {...restProps}
		width={width}
			height={height}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
    }}
    viewBox="0 0 2800 1904"
  >
    <path
      d="M2799.3 1677.18c-315.911 108.437-797.698 177.766-1337.06 177.766-539.36 0-1021.15-69.329-1337.06-177.766 315.91-80.514 797.697-131.99 1337.06-131.99 539.359 0 1021.15 51.476 1337.06 131.99Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M449.932 306.088c22.253-15.327 49.21-24.303 78.248-24.303 76.265 0 138.182 61.917 138.182 138.181H.291A240.44 240.44 0 0 1 0 408.138c0-130.543 105.984-236.526 236.526-236.526 94.007 0 175.278 54.961 213.406 134.476Z"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M2265.28 379.238c-19.683-13.557-43.528-21.497-69.213-21.497-67.457 0-122.224 54.767-122.224 122.224h589.153c.171-3.466.257-6.954.257-10.462 0-115.468-93.744-209.212-209.211-209.212-83.152 0-155.038 48.614-188.762 118.947Z"
      style={{
        fill: "url(#c)",
      }}
    />
    <path
      d="M2508.45 1038.16c-14.385-9.908-31.811-15.711-50.582-15.711-49.3 0-89.325 40.025-89.325 89.325h430.569c.125-2.533.188-5.083.188-7.646 0-84.387-68.511-152.898-152.898-152.898-60.769 0-113.305 35.529-137.952 86.93Z"
      style={{
        fill: "url(#d)",
      }}
    />
    <path
      d="M707.786 424.476 1132.262 0h830.303a41.667 41.667 0 0 1 41.667 41.667v1796.73H707.782V424.477Z"
      style={{
        fill: "url(#e)",
      }}
    />
    <path
      d="M1910.31 136.473c0-9.845-7.992-17.837-17.836-17.837h-646.489c-9.844 0-17.837 7.992-17.837 17.837v35.672c0 9.844 7.993 17.837 17.837 17.837h646.489c9.844 0 17.836-7.993 17.836-17.837v-35.672ZM1910.31 264.143c0-9.844-7.992-17.836-17.836-17.836h-646.489c-9.844 0-17.837 7.992-17.837 17.836v35.673c0 9.844 7.993 17.836 17.837 17.836h646.489c9.844 0 17.836-7.992 17.836-17.836v-35.673ZM1910.31 391.814c0-9.844-7.992-17.836-17.836-17.836h-646.489c-9.844 0-17.837 7.992-17.837 17.836v35.673c0 9.844 7.993 17.836 17.837 17.836h646.489c9.844 0 17.836-7.992 17.836-17.836v-35.673ZM1910.31 519.485c0-9.845-7.992-17.837-17.836-17.837H827.944c-9.844 0-17.837 7.992-17.837 17.837v35.672c0 9.844 7.993 17.837 17.837 17.837h1064.53c9.844 0 17.836-7.993 17.836-17.837v-35.672ZM1910.31 647.155c0-9.844-7.992-17.836-17.836-17.836H827.944c-9.844 0-17.837 7.992-17.837 17.836v35.673c0 9.844 7.993 17.836 17.837 17.836h1064.53c9.844 0 17.836-7.992 17.836-17.836v-35.673ZM1910.31 774.826c0-9.844-7.992-17.837-17.836-17.837H827.944c-9.844 0-17.837 7.993-17.837 17.837v35.672c0 9.845 7.993 17.837 17.837 17.837h1064.53c9.844 0 17.836-7.992 17.836-17.837v-35.672ZM1910.31 902.496c0-9.844-7.992-17.836-17.836-17.836H827.944c-9.844 0-17.837 7.992-17.837 17.836v35.673c0 9.844 7.993 17.836 17.837 17.836h1064.53c9.844 0 17.836-7.992 17.836-17.836v-35.673Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M1132.26 0v429.567H707.954L1132.26 0Z"
      style={{
        fill: "#bdc5cf",
      }}
    />
    <path
      d="m1609.75 1385.18-28.391-170.751-161.716 60.656 230.571-399.36 190.543 110.01-230.716 399.613-.291-.168Z"
      style={{
        fill: "url(#f)",
      }}
    />
    <path
      d="m2212.5 1278.73-162.069-60.788-28.328 170.378-230.571-399.36 190.543-110.011 230.717 399.613-.292.168Z"
      style={{
        fill: "url(#g)",
      }}
    />
    <circle
      cx={1828.43}
      cy={869.265}
      r={329.267}
      style={{
        fill: "#fff",
      }}
    />
    <circle
      cx={1828.43}
      cy={869.265}
      r={329.267}
      style={{
        fill: "url(#h)",
      }}
    />
    <path
      d="m1678.66 826.476 95.545 119.487 204.002-153.396"
      style={{
        fill: "none",
        stroke: "#f4f4f4",
        strokeWidth: "67.76px",
      }}
    />
    <path
      d="M631.678 1811.87v46.871h31.94v-51.974l-31.94 5.103ZM737.327 1811.87v46.871h31.941v-51.974l-31.941 5.103ZM674.418 892.294v-29.531s-14.438-15.592-17.51-34.728c0 0-16.084-19.109-9.26-27.641 3.59-4.489 8.315 1.89 8.315 1.89s-3.355-28.822-11.009-42.288c-7.654-13.466-9.78-21.735-9.78-21.735s60.006-59.298 120.485-.236c0 0 12.349 1.569 10.395 13.939-3.209 20.315-16.064 56.226-16.064 56.226s3.461-8.064 8.493-10.289c5.032-2.226 10.8 6.168 5.091 16.618-5.709 10.451-13.046 14.336-13.046 14.336s-4.957 18.924-17.241 35.225l-.237 35.201-31.184 22.68-27.448-29.667Z"
      style={{
        fill: "#f9b6b1",
      }}
    />
    <clipPath id="i">
      <path d="M674.418 892.294v-29.531s-14.438-15.592-17.51-34.728c0 0-16.084-19.109-9.26-27.641 3.59-4.489 8.315 1.89 8.315 1.89s-3.355-28.822-11.009-42.288c-7.654-13.466-9.78-21.735-9.78-21.735s60.006-59.298 120.485-.236c0 0 12.349 1.569 10.395 13.939-3.209 20.315-16.064 56.226-16.064 56.226s3.461-8.064 8.493-10.289c5.032-2.226 10.8 6.168 5.091 16.618-5.709 10.451-13.046 14.336-13.046 14.336s-4.957 18.924-17.241 35.225l-.237 35.201-31.184 22.68-27.448-29.667Z" />
    </clipPath>
    <g clipPath="url(#i)">
      <path
        d="M658.402 804.099s-3.363-30.618 5.216-37.989c8.58-7.371 19.353-1.89 24.267 4.158 4.914 6.048 29.295-2.646 37.422-6.804 8.127-4.158 24.191-3.402 23.624 13.797-.567 17.199 0 30.618 0 30.618s21.444-26.624 23.751-55.232c2.307-28.608-81.312-75.91-114.073-70.835-32.761 5.076-35.991 77.519-35.991 77.519l35.784 44.768Z"
        style={{
          fill: "#332e30",
        }}
      />
      <path
        d="M740.833 857.195s-20.224 32.76-59.349 10.136c0 0 18.699 19.523 23.653 20.762 4.955 1.238 32.19-1.128 32.19-1.128l3.506-29.77Z"
        style={{
          fill: "#f08788",
        }}
      />
    </g>
    <path
      d="m674.137 1903.39-58.222.118s-3.689-27.632 10.66-44.77h39.5s10.141 16.86 8.062 44.652Z"
      style={{
        fill: "#eeedf2",
      }}
    />
    <clipPath id="j">
      <path d="m674.137 1903.39-58.222.118s-3.689-27.632 10.66-44.77h39.5s10.141 16.86 8.062 44.652Z" />
    </clipPath>
    <g clipPath="url(#j)">
      <path
        d="M613.337 1896.01h62.798v7.502h-62.798z"
        style={{
          fill: "#0c2139",
        }}
      />
    </g>
    <path
      d="m782.338 1903.39-58.222.118s-3.689-27.632 10.66-44.77h39.5s10.141 16.86 8.062 44.652Z"
      style={{
        fill: "#eeedf2",
      }}
    />
    <clipPath id="k">
      <path d="m782.338 1903.39-58.222.118s-3.689-27.632 10.66-44.77h39.5s10.141 16.86 8.062 44.652Z" />
    </clipPath>
    <g clipPath="url(#k)">
      <path
        d="M721.538 1896.01h62.798v7.502h-62.798z"
        style={{
          fill: "#0c2139",
        }}
      />
    </g>
    <path
      d="M1112.93 934.827s13.709-10.966 18.87-19.998c5.161-9.032 20.321-18.063 27.417-24.03 7.096-5.968 12.096-2.742 9.032 4.677-3.065 7.418-8.709 13.87-8.709 13.87s24.514-9.677 27.901-17.741c3.387-8.064 13.386-7.419 13.87 4.677.483 12.096-2.581 32.256-13.064 38.384-10.483 6.129-58.06 20.805-62.414 24.192-4.355 3.387-23.123-10.504-12.903-24.031ZM550.872 1291.48s-4.435 27.417-5.645 40.118 2.016 28.627 9.072 37.497c7.056 8.87 20.16 16.329 23.99 12.297 3.83-4.031-3.226-18.748-3.024-28.828.202-10.08 2.419-4.233 7.257 2.016 4.839 6.25 8.467 6.25 7.459-6.048-1.007-12.297-2.015-11.088-7.66-29.03s-6.25-37.094-6.25-37.094-22.579-12.297-25.199 9.072Z"
      style={{
        fill: "#f9b6b1",
      }}
    />
    <path
      d="m597.999 1267.71 15.771 558.75 65.338 1.127s10.138-403.292 29.289-464.123c0 0 16.974 416.344 14.721 465.911l64.153-1.584s31.797-471.2 33.6-558.618c0 0-191.603 11.493-222.872-1.463Z"
      style={{
        fill: "#062249",
      }}
    />
    <path
      d="m674.654 890.953-18.816 13.608s-63.167 11.424-77.95 19.991c-14.784 8.568-48.047 103.69-48.047 201.741 0 98.052 5.768 171.11 5.768 171.11l51.269 1.922s-9.613-128.171-3.846-159.574c5.768-31.402 23.071-99.333 23.071-99.333s-2.563 103.82-7.049 137.785c-4.486 33.966-1.923 92.284-1.923 92.284s158.292 11.535 228.787-2.564c0 0-19.867-176.877-16.022-232.631 0 0 112.263 41.845 137.857 42.501 25.593.657 181.43-109.949 181.43-109.949s-8.203-42.655-18.457-45.526c-10.254-2.871-166.931 73.417-166.931 73.417S837.566 921.087 818.7 918.626c-18.867-2.46-70.78-18.683-70.78-18.683l-13.171-11.424-19.079 19.921c-5.522 5.765-14.619 6.117-20.57.796l-20.446-18.283Z"
      style={{
        fill: "#7f58ff",
      }}
    />
    <defs>
      <linearGradient
        id="a"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="rotate(89.48 80.739 1378.151) scale(456.65383)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="b"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="rotate(88.826 221.305 38.073) scale(604.0588)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="c"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="scale(-534.302 534.302) rotate(88.826 -2.23 -2.38)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="d"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="matrix(-8.00038 390.4 390.4 8.00038 2634.57 721.375)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="e"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="rotate(90 804.934 782.936) scale(1428.61)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#d9dee4",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#d9dee4",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="f"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="rotate(121.299 563.354 994.597) scale(424.535)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0.7,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="g"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="rotate(61.086 64.474 2227.195) scale(361.588)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0.7,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="h"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="scale(831.43691) rotate(89.706 .777 1.423)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
    </defs>
  </svg>
       
		)};
